import { RowSubfareDto } from "@/dtos";
import { Subfare } from "@/entities";
import { formatToCurrency} from "@/helpers/utilities";

export const formatRowSubfareDto = (subfares: Subfare[]): RowSubfareDto[] => {
    return subfares.map(x => {
        const row: RowSubfareDto = {
            ...x,
            value_label: formatToCurrency(x.value),
            fare_type_label: x.fare_type.name,
        
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}